const getTimestampMs = (value) => {
  if (Number.isFinite(value)) return Number(value);
  if (value && typeof value.toMillis === "function") {
    return value.toMillis();
  }
  if (value && Number.isFinite(value.seconds)) {
    return value.seconds * 1000 + Math.floor((value.nanoseconds || 0) / 1e6);
  }
  const milliseconds = value instanceof Date ? value.getTime() : Date.parse(value);
  if (Number.isFinite(milliseconds)) return milliseconds;
  return Number.POSITIVE_INFINITY;
};

export const orderRepliesChronologically = (replies = []) =>
  [...replies].sort((left, right) => {
    const leftTimestamp = getTimestampMs(left?.created);
    const rightTimestamp = getTimestampMs(right?.created);
    if (leftTimestamp !== rightTimestamp) {
      return leftTimestamp - rightTimestamp;
    }
    return String(left?.id || "").localeCompare(String(right?.id || ""));
  });
